webpackJsonp([6],{

/***/ "2Uyi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/assets/js/store.js

function reJson(value, hour) {
	if (!value) {
		return null;
	}

	var _time = value.split("|")[0];
	var _value = value.replace(_time + "|", "");

	if (hour && +new Date() - _time > hour * 60 * 60 * 1000) {
		return null;
	}

	if (_value && (_value.trim().slice(0, 1) == "{" || _value.trim().slice(0, 1) == "[")) {
		return JSON.parse(_value);
	} else if (_value == "true") {
		return true;
	} else if (_value == "false") {
		return false;
	} else {
		return _value;
	}
}

function Obj2String(obj) {
	var type = Object.prototype.toString.call(obj).slice(8, -1).toUpperCase();
	if (type == "ARRAY" || type == "OBJECT") {
		return stringify_default()(obj);
	} else if (type == "BOOLEAN") {
		if (obj) {
			return "true";
		} else {
			return "false";
		}
	} else {
		return obj;
	}
}

/* harmony default export */ var store = ({
	set: function set(key, value) {
		localStorage.setItem(key, +new Date() + "|" + Obj2String(value));
	},
	get: function get(key, hour) {
		return reJson(localStorage.getItem(key), hour);
	},

	clear: function clear(key) {
		localStorage.removeItem(key);
	},
	clearAll: function clearAll() {
		localStorage.clear();
	}
});
// CONCATENATED MODULE: ./src/assets/js/common.js




var eventBus = new vue_esm["a" /* default */]();
var cacheObj = {};

/* harmony default export */ var common = __webpack_exports__["a"] = ({
	cfg: {
		title: "引力盒子",
		api: "http://www.choicemedia.cn/a/index.php", //'/api',
		domain: 'http://www.choicemedia.cn',
		reg: {
			phone: /^13[0-9]{9}$|14[0-9]{9}$|15[0-9]{9}$|166[0-9]{8}$|17[0-9]{9}$|18[0-9]{9}$|19[89][0-9]{8}$/,
			email: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
			smsCode: /^\d{6}$/
			// emjFilter:/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDE80-\uDEFF]/g
		},
		server: {},
		canWebp: function () {
			var cvs = document.createElement('canvas');
			return cvs.getContext && cvs.toDataURL('image/webp').indexOf('data:image/webp') === 0;
		}()
	},
	isIos: function isIos() {
		var ua = window.navigator.userAgent;
		return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.toLowerCase().match(/MicroMessenger/i) == 'micromessenger';
	},

	event: eventBus,
	store: store,
	cache: {
		get: function get(key) {
			return key in cacheObj ? cacheObj[key] : null;
		},
		set: function set(key, val) {
			cacheObj[key] = val;
		}
	},
	loadingStack: {},
	axios: axios_default.a,
	initWxShare: function initWxShare(payload) {
		var self = this;
		this.ajax({
			op: 'm=App&c=News&a=share',
			send: {
				url: self.isIos() ? window.landingPageUrl : window.location.href
			},
			callback: function callback(data) {
				if (data.status == 1) {
					wx.config({
						debug: false,
						appId: data.data.appid,
						timestamp: data.data.timestamp,
						nonceStr: data.data.noncestr,
						signature: data.data.signature,
						jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
					});
					wx.ready(function () {
						payload.callback();
					});
				}
			}
		});
	},
	getloginData: function getloginData(cb) {
		this.ajax({
			op: "m=App&c=User&a=my_info",
			send: {},
			callback: function callback(data) {
				cb && cb(data);
			}
		});
	},
	rem_init: function rem_init(fixed) {
		var fontSize = 10;
		if (window.screen.width / window.screen.height > 0.72 && window.screen.width >= 768) {
			fontSize = 16;
		} else {
			fontSize = window.screen.width / 320 * 10;
		}
		// if (!fixed || typeof fixed == 'undefined') {
		// 	fontSize = window.screen.width / 320 * 10 < 24 ? window.screen.width / 320 * 10 : 24;
		// }
		document.getElementsByTagName("html")[0].style.fontSize = fontSize + "px";
		window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function () {
			clearTimeout(window.resizePage);
			window.resizePage = setTimeout(function () {
				if (window.screen.width / window.screen.height > 0.72 && window.screen.width >= 768) {
					fontSize = 16;
				} else {
					fontSize = window.screen.width / 320 * 10;
				}
				// if (!fixed || typeof fixed == 'undefined') {
				// 	fontSize = window.screen.width / 320 * 10 < 24 ? window.screen.width / 320 * 10 : 24;
				// }
				document.getElementsByTagName("html")[0].style.fontSize = fontSize + "px";
			}, 50);
		}, false);
		//开发环境显示手机浏览器控制台
		// if (process.env.NODE_ENV === "development") {
		//   (function () {
		//     var script = document.createElement('script');
		//     script.src = "http://eruda.liriliri.io/eruda.min.js";
		//     document.body.appendChild(script);
		//     script.onload = function () {
		//       eruda.init();
		//       eruda.get('console').config.set('overrideConsole', false);
		//     }
		//   })();
		// }
	},

	cancelAjax: null,
	param: function param(obj) {
		var r = '';
		keys_default()(obj).forEach(function (item, index) {
			r += item + "=" + obj[item] + "&";
		});
		r = r.slice(0, -1);
		return r;
	},
	fmtTime: function fmtTime(timestamp) {
		var now = new Date();
		var stamp = new Date(timestamp * 1000);
		if (now.getFullYear() == stamp.getFullYear() && now.getMonth() == stamp.getMonth() && Math.abs(now.getDate() - stamp.getDate() < 2)) {
			if (Math.abs(now.getDate() - stamp.getDate() < 1)) {
				return Math.round(now.getHours() - stamp.getHours()) + "小时前";
			}
			return "昨天";
		} else if (now.getFullYear() == stamp.getFullYear()) {
			return stamp.getMonth() + 1 + '月' + stamp.getDate() + '日';
		} else {
			return stamp.getFullYear() + '年' + (stamp.getMonth() + 1) + '月';
		}
	},
	pad0: function pad0(n) {
		return +n < 10 ? "0" + n : n;
	},
	htmlDecode: function htmlDecode(text) {
		var temp = document.createElement("div");
		temp.innerHTML = text;
		var output = temp.innerText || temp.textContent;
		temp = null;
		return output;
	},

	//公用ajax
	ajax: function ajax(obj) {
		var _self = this;
		var _cacheData = null;
		_self.cancelAjax = axios_default.a.CancelToken.source();
		var _config = {
			timeout: 20000
		};
		if (!obj.noCancel) {
			_config['cancelToken'] = _self.cancelAjax.token;
		}
		var loading_st = null;
		if (!(obj.url || obj.op)) {
			console.warn("ajax参数未传递！");
			return false;
		}
		if (obj.way == 'get' || !obj.way) {
			//组件scope缓存
			// if (obj.dataScope && typeof obj.dataScope[obj.url] !== 'undefined') {
			// 	obj.callback && obj.callback(obj.dataScope[obj.url])
			// }
			//全局变量缓存
			var _url = obj.url || _self.cfg.api + "?" + obj.op;
			if (obj.cacheWay == "state" && _self.cache.get(_url) != null) {
				var _state = _self.cache.get(_url);
				obj.callback && obj.callback(_state);
			}
			//store本地缓存
			else if (obj.cacheWay == "store" && _self.store.get(_url, obj.storeTime)) {
					var _store = _self.store.get(_url);
					obj.callback && obj.callback(_store);
				} else {
					if (typeof obj.noLoading === 'undefined' || !obj.noLoading) {
						loading_st = setTimeout(function () {
							_self.event.$emit('loadingShow', true);
						}, 500);
						_self.loadingStack[loading_st] = true;
					}
					axios_default()({
						method: 'post',
						url: _url,
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded'
						},
						data: obj.send,
						transformRequest: [function (data) {
							var ret = '';
							for (var it in data) {
								ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
							}
							return ret.slice(0, -1);
						}]
					}).then(function (response) {
						//清除延时loading					
						!obj.noLoading && _self.clearLoading(loading_st);
						if (response.data.status == "1") {
							if (obj.dataScope) {
								obj.dataScope[_url] = response.data;
							} else if (obj.cacheWay == "state") {
								_self.cache.set(_url, response.data);
							} else if (obj.cacheWay == "store") {
								_self.store.set(_url, response.data);
							}
						}
						obj.callback && obj.callback(response.data);
					}, function (response) {
						obj.errback && obj.errback(response.data);
						//清除延时loading					
						!obj.noLoading && _self.clearLoading(loading_st);
						if (axios_default.a.isCancel(response)) {
							return false; //手动终止请求不提示错误
						} else {
							obj.error && obj.error(response.data);
							_self.tip("网络异常");
						}
					});
				}
		}
	},

	//函数节流
	funCtrl: function funCtrl(fn, delay, mustRunDelay, timer) {
		var timer = null,
		    t_start;
		return function () {
			var context = this,
			    args = arguments,
			    t_curr = +new Date();
			clearTimeout(timer);
			if (!t_start) {
				t_start = t_curr;
			}
			if (t_curr - t_start >= mustRunDelay) {
				fn.apply(context, args);
				t_start = t_curr;
			} else {
				timer = setTimeout(function () {
					fn.apply(context, args);
				}, delay);
			}
		};
	},
	urlSearchObj: function urlSearchObj() {
		var url = "" + (arguments[0] || window.location.search),
		    _url;
		if (url.indexOf("?") !== 0) {
			return {};
		}
		_url = decodeURI(url.slice(1));
		var _s = _url.split("&");
		var d = {};
		for (var i = 0; i < _s.length; i++) {
			var _v = _s[i].split("=");
			if (_v[0] === 'id' && _v[1].indexOf('!') !== -1) {
				d[_v[0]] = _v[1].slice(0, -1);
			} else {
				d[_v[0]] = _v[1];
			}
		}
		return d;
	},
	clearLoading: function clearLoading(st_code) {
		var _self = this;
		clearTimeout(st_code);
		_self.loadingStack[st_code] = false;
		var canClear = false;
		for (var i in _self.loadingStack) {
			canClear = canClear || _self.loadingStack[i];
		}
		if (canClear == false) {
			_self.event.$emit('loadingShow', false);
		}
	},

	//公用提示
	tip: function tip(payload) {
		this.event.$emit('tip', payload);
	},
	isEmptyObject: function isEmptyObject(obj) {
		for (var n in obj) {
			return false;
		}
		return true;
	},

	rds: function rds(n) {
		var _rs = 'ABCDEFGHIthisLMNOPQRSTUVWXYZabcdefghithislmnopqrstuvwxyz1234567890';
		var r = '';
		for (var i = 0; i < n; i++) {
			r += _rs[parseInt(Math.random() * (_rs.length - 1))];
		}
		return r;
	},
	string: {
		compileStr: function compileStr(code) {
			var c = String.fromCharCode(code.charCodeAt(0) + code.length);
			for (var i = 1; i < code.length; i++) {
				c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
			}
			return escape(c);
		},
		uncompileStr: function uncompileStr(code) {
			code = unescape(code);
			var c = String.fromCharCode(code.charCodeAt(0) - code.length);
			for (var i = 1; i < code.length; i++) {
				c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
			}
			return c;
		}
	}
});

/***/ }),

/***/ "EpV1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [
  // {
  //   path: '/',
  //   name: 'index',
  //   component: function (resolve) {
  //     require(['@/components/index'], resolve)
  //   }
  // },
  // {
  //   path: '/search/:keyword?',
  //   name: 'search',
  //   component: function (resolve) {
  //     require(['@/components/search'], resolve)
  //   }
  // },
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: function (resolve) {
  //     require(['@/components/home'], resolve)
  //   }
  // },
  // {
  //   path: '/my/:tid?/:name?',
  //   name: 'myData',
  //   component: function (resolve) {
  //     require(['@/components/myData'], resolve)
  //   }
  // },
  // {
  //   path: '/teacher/:tid/:name?',
  //   name: 'teacher',
  //   component: function (resolve) {
  //     require(['@/components/myData'], resolve)
  //   }
  // },
  // {
  //   path: '/detail/:tid',
  //   name: 'detail',
  //   component: function (resolve) {
  //     require(['@/components/detail'], resolve)
  //   }
  // },
  // {
  //   path: '/share/:tid',
  //   name: 'shareDp',
  //   component: function (resolve) {
  //     require(['@/components/shareDp'], resolve)
  //   }
  // },
  // {
  //   path: '/comment/:tid',
  //   name: 'comment',
  //   component: function (resolve) {
  //     require(['@/components/comment'], resolve)
  //   }
  // },
  // {
  //   path: '/dianp/:tid',
  //   name: 'dianp',
  //   component: function (resolve) {
  //     require(['@/components/dianp'], resolve)
  //   }
  // },
  // {
  //   path: '/setting/:status?',
  //   name: 'setting',
  //   component: function (resolve) {
  //     require(['@/components/setting'], resolve)
  //   }
  // },
  {
    path: '/',
    name: 'game',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1cCc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/game/:id',
    name: 'gameOne',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("srpN")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/game/',
    name: 'gameList',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("1cCc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/gameshare/:info',
    name: 'gameShare',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Q19p")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/result/:id',
    name: 'result',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mKPe")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
}));
// EXTERNAL MODULE: ./node_modules/.0.1.0@vue-clipboard2/vue-clipboard.js
var vue_clipboard = __webpack_require__("7QzW");
var vue_clipboard_default = /*#__PURE__*/__webpack_require__.n(vue_clipboard);

// EXTERNAL MODULE: ./src/assets/js/common.js + 1 modules
var common = __webpack_require__("2Uyi");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//




vue_esm["a" /* default */].use(vue_clipboard_default.a);

/* harmony default export */ var App = ({
  name: 'App',
  data: function data() {
    return {
      loadingShow: false,
      stLoading: null,
      tipText: '',
      tipShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    common["a" /* default */].event.$on('loadingShow', function (state) {
      clearTimeout(_this.stLoading);
      if (state) {
        _this.stLoading = setTimeout(function () {
          _this.loadingShow = true;
        }, 500);
      } else {
        _this.loadingShow = false;
      }
    });
    common["a" /* default */].event.$on('tip', function (payload) {
      _this.tipText = payload.text || payload;
      _this.tipShow = true;
      setTimeout(function () {
        _this.tipShow = false;
        _this.tipText = '';
      }, payload.time || 3000);
    });
    common["a" /* default */].event.$on('playerShow', function (state) {
      _this.playerShow = state;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//




vue_esm["a" /* default */].use(vue_clipboard_default.a);

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'App',
  data: function data() {
    return {
      loadingShow: false,
      stLoading: null,
      tipText: '',
      tipShow: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    common["a" /* default */].event.$on('loadingShow', function (state) {
      clearTimeout(_this.stLoading);
      if (state) {
        _this.stLoading = setTimeout(function () {
          _this.loadingShow = true;
        }, 500);
      } else {
        _this.loadingShow = false;
      }
    });
    common["a" /* default */].event.$on('tip', function (payload) {
      _this.tipText = payload.text || payload;
      _this.tipShow = true;
      setTimeout(function () {
        _this.tipShow = false;
        _this.tipText = '';
      }, payload.time || 3000);
    });
    common["a" /* default */].event.$on('playerShow', function (state) {
      _this.playerShow = state;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b700c6ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"},on:{"~click":function($event){_vm.$copyText('ZzOoa175kF')}}},[_c('router-view'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loadingShow),expression:"loadingShow"}],staticClass:"loadingWrap"},[_vm._m(0)]),_vm._v(" "),_c('div',{class:{tipWrap:true,show:_vm.tipShow}},[_c('div',{staticClass:"tipText",domProps:{"innerHTML":_vm._s(_vm.tipText)}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('i',{staticClass:"load_icon"}),_c('br'),_c('span',[_vm._v("加载中")])])}]
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("EpV1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// CONCATENATED MODULE: ./src/main.js


// import VueRouter from 'vue-router'




window.jK = common["a" /* default */]; //微信控制台调试快速对象 正式上线删除
window.landingPageUrl = window.location.href;
// Vue.use(VueRouter)

// const routes = [{
//   path: '/',
//   component: App
// }]

// const router = new VueRouter({
//   routes
// })

common["a" /* default */].rem_init();

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
// new Vue({
//   router,
//   render: h => h(App)
// }).$mount('#app-box')


if (window.location.href.indexOf('localhost') >= 0 || window.location.href.indexOf('192.168.') >= 0) {
  new vue_esm["a" /* default */]({
    router: router,
    render: function render(h) {
      return h(src_App);
    }
  }).$mount('#app-box');
} else {
  common["a" /* default */].ajax({
    op: "m=App&c=User&a=my_info",
    send: {},
    callback: function callback(data) {
      console.log(data);
      if (data.status == 1) {
        common["a" /* default */].store.set("userLoginData", data.data);
        new vue_esm["a" /* default */]({
          router: router,
          render: function render(h) {
            return h(src_App);
          }
        }).$mount('#app-box');
      } else {
        window.location.href = 'http://www.choicemedia.cn/a/index.php?m=App&c=Login&a=dologin';
      }
    }
  });
}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.970c98dd2c0f452132aa.js